import apiClient from '../index';

export const createOrganization = async (organizationData) => {
  try {
    const response = await apiClient.post('/api/org', organizationData);
    // Validate and normalize the response data
    const data = response.data?.data || response.data;
    if (!data) {
      throw new Error('No data received from server');
    }
    // Ensure we have an ID field
    if (!data.id && !data._id && !data.organizationId) {
      throw new Error('Invalid organization data: missing ID');
    }
    return data;
  } catch (error) {
    console.error('Error creating organization:', error);
    throw error;
  }
};

export const getOrganizationById = async (id) => {
  try {
    const response = await apiClient.get(`/api/org/${id}`);
    const data = response.data?.data || response.data;
    if (!data) {
      throw new Error('No data received from server');
    }
    return data;
  } catch (error) {
    console.error('Error fetching organization data:', error);
    throw error;
  }
};

export const updateOrganization = async (id, organizationData) => {
  try {
    const response = await apiClient.put(`/api/org/`, organizationData);
    const data = response.data?.data || response.data;
    if (!data) {
      throw new Error('No data received from server');
    }
    return data;
  } catch (error) {
    console.error('Error updating organization:', error);
    throw error;
  }
};

export const deleteOrganization = async (id) => {
  try {
    const response = await apiClient.delete(`/api/org/`);
    return response.data?.data || response.data;
  } catch (error) {
    console.error('Error deleting organization:', error);
    throw error;
  }
};
